import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.WorkflowSettingPopupContent.SectionFeaturePromotion', {
    label: 'Advanced plan',
    tryIt: 'Try it for free',
});
